import React from 'react'
import "./css/header.css"
import "./css/register.css"

function Register() {
  return (
    <div className='login'>
     <div className='loginWrapper'>
       <div className='loginLeft'>
         <h3 className='loginLogo'> HMS</h3>
         <span className='loginDesc'> Log in to begin</span>

       </div>
       <div className='loginRight'>
         <div className='loginBox'>
           <input placeholder="Username" className="loginInput" />
           <input placeholder="Email" className="loginInput" />
           <input placeholder="Password" className="loginInput" />
           <input placeholder="Password Again" className="loginInput" />
           <button className="loginButtton">Sign Up</button>
           
           <button className="loginRegisterButton">Log into Account</button>
         
         
         </div>

       </div>
      

     </div>

    </div>
  )
}

export default Register;